import { http, HttpResponse } from 'msw';

export const mockPermissions = [
  {
    id: '4e1ae27c-271b-4325-bc26-511f62dbf97f',
    resource: 'submissions',
    action: 'modify',
  },
  {
    id: '172878f5-0c0d-4de9-b7f2-6fb03a9356b3',
    resource: 'roles',
    action: 'modify',
  },
  {
    id: '2827ffa4-9368-44a8-96c6-f1db6898bef0',
    resource: 'users',
    action: 'modify',
  },
  {
    id: 'e3808da0-ce1a-4ce2-b7f4-e1ae62c13756',
    resource: 'rules',
    action: 'modify',
  },
  {
    id: '44ead7a7-6e7c-46d8-a88d-26e2ee97737a',
    resource: 'reports',
    action: 'modify',
  },
  {
    id: '0b0ea386-8e85-4dde-946e-b013812e5391',
    resource: 'sites',
    action: 'modify',
  },
  {
    id: 'deb3c865-282a-4ac2-bb50-ec32f9539bf3',
    resource: 'claims',
    action: 'modify',
  },
  {
    id: '9b4d7f0a-2e73-4d8d-8d7a-1c5b9c55e3f1',
    resource: 'uploads',
    action: 'modify',
  },
  {
    id: '6616410f-5592-48fb-bd11-7097fe59c5cb',
    resource: 'uploads',
    action: 'upload',
  },
  {
    id: '6f770a35-4ffd-423d-8d6a-a47e7d4c7780',
    resource: 'providers',
    action: 'modify',
  },
  {
    id: '1414fd99-cfae-49dd-9382-00fcfab731b5',
    resource: 'remittances',
    action: 'modify',
  },
  {
    id: '222ab4a1-f0e3-4177-b906-1743cc8b3338',
    resource: 'eobs',
    action: 'modify',
  },
  {
    id: 'a7b14d62-4243-4f03-b9b9-5edcc5240df7',
    resource: 'credits',
    action: 'modify',
  },
  {
    id: 'd05f267c-7708-4a6b-ae66-a52c783c020d',
    resource: 'statements',
    action: 'modify',
  },
  {
    id: '0141fe2e-2eb6-4735-b889-dfe5ec1f6a3f',
    resource: 'transactions',
    action: 'modify',
  },
  {
    id: '063019da-9a83-4632-a105-710f5632ac0b',
    resource: 'organizations',
    action: 'modify',
  },
  {
    id: '7f9a0176-0678-4d52-8f0c-b6520f4fa4b1',
    resource: 'payors',
    action: 'modify',
  },
  {
    id: '8a2c9d44-14a5-46e4-82a5-7cb28e9fdf63',
    resource: 'queries',
    action: 'create',
  },
  {
    id: '929d0cf0-fda1-4b08-9b3d-1d8d40819e76',
    resource: 'queries',
    action: 'view',
  },
  {
    id: 'ab674e9a-a565-45ba-a9cd-d4a91de8f1c8',
    resource: 'queries',
    action: 'modify',
  },
];

export const mockPermissionHandlers = [
  http.get('*/resource/permission', () => {
    return HttpResponse.json(mockPermissions);
  }),
];
